/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Testimonials Slider js
(function () {

	if (!window.Swiper) {
		console.warn('Swiper library not loaded');
	};

	const testimonialsSliders = document.querySelectorAll('.js-testimonials-slider');
	testimonialsSliders.forEach((sliderInstance, index) => {
		console.log('Initializing Testimonials Slider', index);
		sliderInstance.classList.add('testimonials-slider' + index);
		console.log(sliderInstance.classList);

		sliderInstance = new Swiper('.testimonials-slider' + index, {
			loop: true,
			// loopAddBlankSlides: true,
			// loopAdditionalSlides: 3,
			// rewind:true,
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			spaceBetween: 20,
			preloadImages: false,
			// lazy: {
			//   checkInView:true,
			//   loadPrevNext:true,
			//   enabled:true
			// },
			// autoplay: {
			//   delay: 4000,
			// },
			speed: 400,
			autoHeight: false,
			// Navigation arrows
			navigation: {
				nextEl: `.testimonials-slider${index} .next-slide-btn`,
				prevEl: `.testimonials-slider${index} .prev-slide-btn`,
			},
			breakpoints: {
			}
		});
	});

})();

